import { FC } from "react";
import Container from "@/components/Container";
import ClientsSaySlider from "@/components/ClientsSay/ClientsSaySlider";
import ActionLink from "@/components/UI/Buttons/ActionLink";
import ROUTES from "@/data/Routes";

interface ClientsSayProps {
  isMobile: boolean;
}

const ClientsSay: FC<ClientsSayProps> = ({ isMobile }) => {
  return (
    <section className="flex flex-col bg-white px-4 py-15 md:px-6 md:py-25">
      <Container>
        <div className="flex flex-col items-center justify-center gap-10 self-stretch">
          <h2 className="text-dark text-6 md:text-8.5 m-0 text-center leading-[120%] font-light">
            Ką apie mus sako pacientai
          </h2>
          <div className="w-full">
            <ClientsSaySlider
              isMobile={isMobile}
              initialSlide={0}
            />
          </div>
          <ActionLink
            to={ROUTES.CONSULTATION}
            variant="dark"
            hoverGradientLight
            onHover
            className="hidden w-full md:flex md:w-auto"
          >
            Registruotis konsultacijai
          </ActionLink>
        </div>
      </Container>
    </section>
  );
};

export default ClientsSay;
